<template>
  <motlet :options="motletOptions">
    <template #content>
      <v-row class="h-100">
        <v-col col="6">
          <v-card class="card-wrap">
            <v-card-title>{{ $t('ov.sys.title.heap.mem') }}</v-card-title>
            <v-card-text class="chart-area">
              <!-- eslint-disable-next-line prettier/prettier -->
              <heap-memory
                :system="system"
                :items="instances"
                :values="heapMemory"
                :formatter="formatter.heapMemory"
                :max="100"
                :selected-descendant.sync="selectedDescendant"
                :contextmenu="contextmenuChart"
              />
            </v-card-text>
          </v-card>
        </v-col>
        <v-col col="6">
          <v-card class="card-wrap">
            <v-card-title>{{ $t('ov.sys.title.ext.mem') }}</v-card-title>
            <v-card-text class="chart-area">
              <!-- eslint-disable-next-line prettier/prettier -->
              <extended-memory
                :system="system"
                :items="instances"
                :values="extendedMemory"
                :formatter="formatter.extendedMemory"
                :max="100"
                :selected-descendant.sync="selectedDescendant"
                :contextmenu="contextmenuChart"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </template>
    <template #menu>
      <contextmenu :options="contextmenuParam"></contextmenu>
    </template>
  </motlet>
</template>

<script>
import { cloneDeep } from 'lodash';
import instanceable from '@/views/overview/system/abap/mixins/instanceable';
import contextmenuable from '@/views/overview/system/abap/mixins/contextmenuable';
import ExtendedMemory from '@/views/overview/system/chart/BarVertical.vue';
import HeapMemory from '@/views/overview/system/chart/BarVertical.vue';

export default {
  mixins: [instanceable, contextmenuable],
  components: {
    ExtendedMemory,
    HeapMemory,
  },
  data() {
    return {
      motletOptions: {
        id: 'overview/system/abap/InstanceSummary',
        title: this.$t('ov.sys.title.inst.sum'),
      },
      messageSequence: 0,
      values: {
        extendedMemory: {},
        heapMemory: {},
      },
      extendedMemory: {},
      heapMemory: {},
      formatter: {
        extendedMemory: param => `${Math.round(param.value)} %`,
        heapMemory: param => `${Math.round(param.value)} %`,
      },
      contextmenuUrl: '/views/detailview/abap/process',
      selectedDescendant: {},
    };
  },
  watch: {
    instances: {
      handler: 'changeInstancesHandler',
    },
  },
  methods: {
    contextmenuChart(event) {
      this.onContextmenuChart(event, this.selectedDescendant);
    },
    wsDataHandler(key, response) {
      ++this.messageSequence;

      // 인스턴스 별 초기화
      if (key.name == 'rawMemory') {
        this.values.extendedMemory[key.instId] = 0.0;
      }

      response.forEach(res => {
        if (key.name == 'rawMemory') {
          if (res.areaName == 'EXTENDED MEMORY') this.values.extendedMemory[key.instId] = parseFloat(res.currUsedP).toFixed(2);
          if (res.areaName == 'HEAP MEMORY') this.values.heapMemory[key.instId] = parseFloat(res.currUsedP).toFixed(2);
        }
      });

      // 모든 인스턴스 값이 지정되었을 경우
      if (this.messageSequence == this.instances.length) {
        this.extendedMemory = cloneDeep(this.values.extendedMemory);
        this.heapMemory = cloneDeep(this.values.heapMemory);
        this.messageSequence = 0;
      }
    },
    sendMessage() {
      this.$websocket.realtime.send({
        requests: this.instances.map(instance => ({
          key: { name: 'rawMemory', sstmId: instance.systemId, instId: instance.id },
          fields: ['areaName', 'currUsedP'],
          handler: {
            every: this.wsDataHandler,
          },
        })),
      });
    },
    initialize() {
      this.messageSequence = 0;
      // value init
      Object.keys(this.values).forEach(key => (this.values[key] = {}));
      this.extendedMemory = {};
      this.heapMemory = {};

      // websoket message init
      this.wsRequestMessages = {};
    },
    changeInstancesHandler() {
      this.initialize();
      this.sendMessage();
    },
  },
};
</script>

<style scoped>
.chart-area {
  height: calc(100% - 37px);
}
</style>
